import React from 'react';
import Modal from '../../../components/modals';
import Select, { components } from 'react-select';
import { gql } from '@apollo/client';
import _ from 'lodash';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import InputHeader from '../../global/inputwithHeader';
import LoadingBar from '../../global/loadingBar';

import jwt_decode from 'jwt-decode';
import moment from 'moment';
import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as MinusIcon } from '../../../../assets/svg/Project/minus-circle.svg';
import { ReactComponent as DownIcon } from '../../../../assets/svg/arrow-ios-downward.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { withRouter } from '../../../../services/withRoute';

const assignMemoryCard = gql`
	mutation AssignMemoryCard(
		$qrCodes: [String!]!
		$workspaceId: String!
		$assignedTo: LogUserInput!
		$projectId: ID!
		$eventId: ID!
	) {
		assignMemoryCard(
			qrCodes: $qrCodes
			workspaceId: $workspaceId
			assignedTo: $assignedTo
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

const GetMcTransactionLogs = gql`
	query McTransactionLogs($filters: McTransactionListFiltersInput) {
		mcTransactionLogs(filters: $filters) {
			data {
				description
				eventId
				eventName
				createdAt
				id
				isDamaged
				isEmpty
				isReceived
				mcId
				projectName
				projectId
				qrCode
				status
				tenantId
				userId
				userName
				workspaceId
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;

const getEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			data {
				id
				name
				slNo
				crew {
					count
					role
					managerIds
					subRole
					userIds
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				childEvents {
					_id
					name
				}
			}
			hasNextPage
		}
	}
`;

const getMemoryCard = gql`
	query MemoryCard($qrCode: String!) {
		memoryCard(qrCode: $qrCode) {
			id
			manufacturer
			manufacturerId
			qrCode
			status
			description
		}
	}
`;

const getProjectList = gql`
	query VendorsProjects($workspaceIds: [String!]) {
		vendorsProjects(workspaceIds: $workspaceIds) {
			id
			title
		}
	}
`;

const getTenantUsersListForMc = gql`
	query VendorTenantUsersList($filters: TenantUsersFiltersInput) {
		vendorTenantUsersList(filters: $filters) {
			data {
				id
				firstName
				lastName
				email
				isEmailVerified
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
	}
`;

class AssignMemoryCard extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			showDropDown: false,
			currStep: '2',
			projectId: null,
			eventId: null,
			projectNameOptions: [{ value: null, label: 'Select Project' }],
			projectsNameList: [],
			eventNameOptions: [{ value: null, label: 'Select Event' }],
			projectSlNo: null,
			eventSlNo: null,
			mcList: [],
			qrCodeInputValue: '',
			assignToOptions: [{ value: null, label: 'Select User' }],
			assignedTo: null,
			limit: 10,
			page: 1,
			hasNextPage: true,
			eventLimit: 10000,
			eventPage: 1,
			hasNextEventsPage: true,
			isProjectsLoading: true,
			isEventsLoading: true,
			eventsNameList: [],
			disabledBtn: false,
			isMcFetching: false,
			qrCodeError: false,
			qrCodeErrorMessage: '',
			isAssignError: false,
			isAssignErrorMessage: '',
			isTenantUsersLoading: false,
			tenantUsersList: {},
			tenantUsersListOptions: [],
			currUserId: null,
			currUserName: '',
			isAssignLoading: false,
		};
		this.dropdownref = React.createRef();
	}
	timer = null;

	DropdownIndicator = (props) => {
		return (
			<components.DropdownIndicator {...props}>
				<DownIcon />
			</components.DropdownIndicator>
		);
	};
	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);

		let userToken = localStorage.getItem('usertoken');
		let decoded = jwt_decode(userToken);

		this.setState({
			currUserId: decoded.user_id,
			currUserName: decoded.userName,
		});
		if (_.has(this.props.params, 'projectID') && _.has(this.props.params, 'shootID')) {
			this.setState({
				projectId: this.props.params.projectID,
				eventId: this.props.params.shootID,
				projectNameOptions: [
					{
						value: this.props.params.projectID,
						label: this.props.eventDetails.projectTitle,
					},
				],
				projectsNameList: [
					{
						id: this.props.params.projectID,
						slNo: this.props.eventDetails.projectSlNo,
					},
				],
				eventNameOptions: [
					{
						value: this.props.params.shootID,
						label: this.props.eventDetails.name,
					},
				],
				eventsNameList: [
					{
						id: this.props.params.shootID,
						slNo: this.props.eventDetails.slNo,
					},
				],
				tenantUsersListOptions: [
					{
						value: null,
						label: 'Select User',
					},
				],
				projectSlNo: this.props.eventDetails.projectSlNo,
				eventSlNo: this.props.eventDetails.slNo,
			});
		} else {
			const getProjectsVeriables = {
				workspaceIds: this.props.params.workspaceID,
			};

			await this.getProjectNameList(getProjectList, getProjectsVeriables);
		}

		let json = {
			filters: { limit: 10000, page: 1, workspaceIds: this.props.params.workspaceID },
		};
		let tenantUsersList = await this.getTenantUsersListForMc(getTenantUsersListForMc, json);

		if (
			_.has(this.props.params, 'projectID') &&
			_.has(this.props.params, 'shootID') &&
			tenantUsersList
		) {
			let tenantUsersListOptions = [{ value: null, label: 'Select User' }];
			let crew = [];
			let selectedEvent = this.props.eventDetails;

			_.forEach(selectedEvent.crewNew, (cr, inx) => {
				if (crew.userId !== null && crew.isCustomUser !== true) {
					crew.push(cr.userId);
				}
			});
			if (_.size(crew) > 0 && _.size(tenantUsersList) > 0) {
				let tempTenantUsers = [];
				tempTenantUsers = _.filter(tenantUsersList, (user, i) => {
					let found = undefined;
					found = _.find(crew, (u, inx) => {
						return u === user.id;
					});
					if (found) {
						return true;
					} else {
						return false;
					}
				});
				if (_.size(tempTenantUsers) > 0) {
					_.forEach(tempTenantUsers, (user, key) => {
						tenantUsersListOptions.push({
							label: user.firstName + ' ' + user.lastName,
							value: user.id,
						});
					});
				}
			}

			this.setState({
				tenantUsersListOptions,
				isTenantUsersLoading: false,
				isMcFetching: false,
				isProjectsLoading: false,
			});
		}
	};

	componentWillUnmount = () => {
		clearTimeout(this.timer);
		document.removeEventListener('mousedown', this.handleClickOutside);
	};

	handleClickOutside = (event) => {
		if (this.dropdownref.current && !this.dropdownref.current.contains(event.target)) {
			this.setState({
				showDropDown: false,
			});
		}
	};

	toggleDropDown = (e) => {
		this.setState({
			showDropDown: !this.state.showDropDown,
		});
	};

	handleCloseModal = () => {
		this.setState({ showDiscardModal: true });
	};

	handleProjectChange = (e) => {
		this.setState(
			{
				projectId: e.value,
				eventId: null,
				assignedTo: null,
				tenantUsersListOptions: [{ value: null, label: 'Select User' }],
			},
			() => {
				if (this.state.projectId === null) {
					this.setState({
						eventNameOptions: [{ value: null, label: 'Select Event' }],
					});
				} else {
					this.setState(
						{
							eventPage: 1,
							hasNextEventsPage: true,
							eventNameOptions: [{ value: null, label: 'Select Event' }],
						},
						() => {
							const getEventsVariables = {
								filters: {
									projectId: this.state.projectId,
									page: this.state.eventPage,
									limit: this.state.eventLimit,
									//"wsTenantIds": "5f96f2ade0465a32bbb62de5",
								},
							};
							this.getProjectNameList(getEventsList, getEventsVariables, 'expense');
						},
					);
				}
			},
		);
	};

	fetchMoreOptions = async () => {
		if (this.state.hasNextPage === true) {
			this.setState({ page: this.state.page + 1 }, async () => {
				const getProjectsVariables = {
					workspaceIds: this.props.params.workspaceID,
				};
				await this.getProjectNameList(getProjectList, getProjectsVariables);
			});
		}
	};

	handleQrCodeInput = (e) => {
		this.setState(
			{ qrCodeInputValue: e.target.value, qrCodeError: false, qrCodeErrorMessage: '' },
			async () => {
				clearTimeout(this.timer);
				this.timer = setTimeout(
					async () => {
						if (_.size(this.state.qrCodeInputValue.trim()) > 0) {
							if (
								_.findIndex(this.state.mcList, {
									qrCode: this.state.qrCodeInputValue.trim(),
								}) !== -1
							) {
								this.setState({
									qrCodeErrorMessage: 'Duplicate qrCode',
									qrCodeError: true,
								});
							} else {
								let getMCVariables = {
									qrCode: this.state.qrCodeInputValue,
								};

								await this.getMemoryCard(getMemoryCard, getMCVariables);
							}
						}
					},
					_.size(e.target.value.trim()) === 0 ? 0 : 500,
				);
			},
		);
	};

	handleAssignMC = async () => {
		this.setState({ isAssignLoading: true });
		let assignMCVariables = {
			qrCodes: _.map(this.state.mcList, (item, i) => {
				return item.qrCode;
			}),
			assignedTo: { id: this.state.assignedTo, name: this.state.assignedToCrew },
			projectId: this.state.projectId,
			eventId: this.state.eventId,
			workspaceId: this.props.params.workspaceID,
		};

		this.assignMemoryCard(assignMemoryCard, assignMCVariables);
	};

	handleEventChange = (e) => {
		this.setState(
			{
				eventId: e.value,
				assignedTo: null,
				assignedToCrew: null,
				tenantUsersListOptions: [
					{
						value: null,
						label: 'Select User',
					},
				],
			},
			() => {
				if (this.state.eventId) {
					let eventsNameList = this.state.eventsNameList;
					let tenantUsersList = this.state.tenantUsersList;

					let crew = [];
					let selectedEvent = undefined;
					selectedEvent = _.find(eventsNameList, { id: this.state.eventId });
					if (selectedEvent) {
						_.forEach(selectedEvent.crewNew, (cr, inx) => {
							if (crew.userId !== null && crew.isCustomUser !== true)
								crew.push(cr.userId);
						});
						if (_.size(crew) > 0 && _.size(tenantUsersList) > 0) {
							let tempTenantUsers = [];
							tempTenantUsers = _.filter(tenantUsersList, (user, i) => {
								let found = undefined;
								found = _.find(crew, (u, inx) => {
									return u === user.id;
								});
								if (found) {
									return true;
								} else {
									return false;
								}
							});
							if (_.size(tempTenantUsers) > 0) {
								let tenantUsersListOptions = [
									{ value: null, label: 'Select User' },
								];
								_.forEach(tempTenantUsers, (user, key) => {
									tenantUsersListOptions.push({
										label: user.firstName + ' ' + user.lastName,
										value: user.id,
									});
								});
								this.setState({
									tenantUsersListOptions,
								});
							}
						}
					}
				}
			},
		);
	};

	handleDeleteItemMcList = (index) => {
		let mcList = _.cloneDeep(this.state.mcList);
		mcList.splice(index, 1);
		this.setState({ mcList });
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
			>
				<div className="memory-card-modal-container">
					{this.state.isTenantUsersLoading || this.state.isProjectsLoading ? (
						<LoadingBar />
					) : (
						<>
							<div className="mc-header-container">
								<div className="header-left-container">
									<div className="header-title-container">
										<span className="header-title">ASSIGN MEMORY CARDS</span>
									</div>
								</div>
							</div>
							{this.state.currStep !== '4' ? (
								<div className="mc-body-container">
									{this.state.currStep !== '1' ? (
										<div className="mc-body-section-container">
											<div
												className="mc-body-section-header"
												onClick={() => {
													if (this.state.currStep !== '1') {
														this.setState({ currStep: '1' });
													}
												}}
											>
												<span className="section-header-title">
													Project & Event Details
												</span>
												<span className="section-header-down-icn">
													<DownIcon />
												</span>
											</div>
										</div>
									) : (
										<div className="mc-body-section-container">
											<div className="mc-body-section-header">
												<span className="section-header-title">
													Project & Event Details
												</span>
												<span className="section-header-down-icn expanded">
													<DownIcon />
												</span>
											</div>
											<div className="mc-section-item">
												<div className="mc-section-item-left">
													<InputHeader
														type="text"
														name="projectCode"
														isInputError={false}
														label="Project code"
														value={
															this.state.projectId
																? _.find(
																		this.state.projectsNameList,
																		{
																			id: this.state
																				.projectId,
																		},
																  )
																	? `PJ- ${
																			_.find(
																				this.state
																					.projectsNameList,
																				{
																					id: this.state
																						.projectId,
																				},
																			).slNo
																	  }`
																	: ''
																: ''
														}
														width="100%"
														marginBottom="0px"
														readOnly={true}
													/>
												</div>
												<div className="mc-section-item-right">
													<div className="floating-select-container">
														<label>
															Project name
															<span className="required-star">*</span>
														</label>
														<Select
															className={
																'cost-select-container zIndex5 w-100p' +
																(_.has(
																	this.props.params,
																	'projectID',
																) &&
																_.has(this.props.params, 'shootID')
																	? ' cost-select--is-disabled'
																	: '')
															}
															classNamePrefix="cost-select"
															options={this.state.projectNameOptions}
															onChange={(e) =>
																this.handleProjectChange(e)
															}
															components={{
																DropdownIndicator:
																	this.DropdownIndicator,
															}}
															defaultValue={
																this.state.projectId === null
																	? this.state
																			.projectNameOptions[0]
																	: _.find(
																			this.state
																				.projectNameOptions,
																			{
																				value: this.state
																					.projectId,
																			},
																	  )
															}
															onMenuScrollToBottom={(e) =>
																this.fetchMoreOptions()
															}
															isDisabled={
																_.has(
																	this.props.params,
																	'projectID',
																) &&
																_.has(this.props.params, 'shootID')
															}
															isSearchable={false}
														/>
													</div>
												</div>
											</div>
											<div className="mc-section-item">
												<div className="mc-section-item-left">
													<InputHeader
														type="text"
														name="shootCode"
														isInputError={false}
														label="Shoot code"
														value={
															this.state.eventId
																? _.find(
																		this.state.eventsNameList,
																		{
																			id: this.state.eventId,
																		},
																  )
																	? `ST- ${
																			_.find(
																				this.state
																					.eventsNameList,
																				{
																					id: this.state
																						.eventId,
																				},
																			).slNo
																	  }`
																	: ''
																: ''
														}
														onChange={(e) => {}}
														errorMessage={''}
														width="100%"
														marginBottom="0px"
														readOnly={true}
													/>
												</div>
												<div className="mc-section-item-right">
													<div className="floating-select-container">
														<label>
															Event name
															<span className="required-star">*</span>
														</label>
														<Select
															className={
																'cost-select-container zIndex4 w-100p' +
																(_.has(
																	this.props.params,
																	'projectID',
																) &&
																_.has(this.props.params, 'shootID')
																	? ' cost-select--is-disabled'
																	: '')
															}
															classNamePrefix="cost-select"
															options={this.state.eventNameOptions}
															onChange={(e) =>
																this.handleEventChange(e)
															}
															defaultValue={
																this.state.eventId === null
																	? this.state.eventNameOptions[0]
																	: _.find(
																			this.state
																				.eventNameOptions,
																			{
																				value: this.state
																					.eventId,
																			},
																	  )
															}
															components={{
																DropdownIndicator:
																	this.DropdownIndicator,
															}}
															isDisabled={
																_.has(
																	this.props.params,
																	'projectID',
																) &&
																_.has(this.props.params, 'shootID')
															}
															isSearchable={true}
														/>
													</div>
												</div>
											</div>
										</div>
									)}
									{this.state.currStep !== '2' ? (
										<div className="mc-body-section-container">
											<div
												className="mc-body-section-header"
												onClick={() => {
													if (
														this.state.currStep !== '2' &&
														this.state.projectId &&
														this.state.eventId
													) {
														this.setState({ currStep: '2' }, () => {
															if (
																document.getElementById(
																	'qrCodeId-kjsdfk4df54g4dfg5d4f',
																)
															) {
																document
																	.getElementById(
																		'qrCodeId-kjsdfk4df54g4dfg5d4f',
																	)
																	.focus();
															}
														});
													}
												}}
											>
												<span className="section-header-title">
													Scan / Add Memory cards (
													{_.size(this.state.mcList)})
												</span>
												<span className="section-header-down-icn">
													<DownIcon />
												</span>
											</div>
										</div>
									) : (
										<div className="mc-body-section-container">
											<div className="mc-body-section-header">
												<span className="section-header-title">
													Scan / Add Memory cards
												</span>
												<span className="section-header-down-icn expanded">
													<DownIcon />
												</span>
											</div>
											<table className="mc-table">
												{_.size(this.state.mcList) > 0 ? (
													<thead>
														<tr>
															<th>QR CODE</th>
															<th>Description</th>
															<th>READY TO USE</th>
															<th></th>
														</tr>
													</thead>
												) : null}
												<tbody>
													{_.map(this.state.mcList, (mc, index) => {
														return (
															<tr>
																<td>
																	<div
																		className={
																			'mc-table-cell' +
																			(mc.status === 'ready'
																				? ''
																				: ' red-color-text')
																		}
																	>
																		{mc.qrCode.toUpperCase()}
																	</div>
																</td>
																<td>
																	<div
																		className={
																			'mc-table-cell' +
																			(mc.status === 'ready'
																				? ''
																				: ' red-color-text')
																		}
																	>
																		<span>
																			{mc.description}
																		</span>
																	</div>
																</td>
																<td>
																	<div
																		className={
																			'mc-table-cell' +
																			(mc.status === 'ready'
																				? ' green-color-text'
																				: ' red-color-text')
																		}
																	>
																		{mc.status === 'ready'
																			? 'Yes'
																			: 'No'}
																	</div>
																</td>
																<td>
																	<div
																		className="minu-circle"
																		onClick={() =>
																			this.handleDeleteItemMcList(
																				index,
																			)
																		}
																	>
																		<MinusIcon />
																	</div>
																</td>
															</tr>
														);
													})}
													<tr className="type-qr-code-input">
														<td colSpan="4">
															<input
																id="qrCodeId-kjsdfk4df54g4dfg5d4f"
																type="text"
																value={this.state.qrCodeInputValue}
																placeholder="Type QR code"
																onChange={(e) => {
																	if (
																		this.state.isMcFetching ===
																		false
																	) {
																		this.handleQrCodeInput(e);
																	}
																}}
																autoFocus={true}
																readOnly={
																	this.state.isAssignLoading
																}
															/>
															{this.state.isMcFetching ? (
																<span className={'loading-btn'}>
																	<LoadingBar />
																</span>
															) : (
																''
															)}
														</td>
													</tr>
												</tbody>
											</table>
											{this.state.qrCodeError ? (
												<div className="mc-error">
													{this.state.qrCodeErrorMessage}
												</div>
											) : null}
										</div>
									)}
									{this.state.currStep !== '3' ? (
										<div className="mc-body-section-container">
											<div
												className="mc-body-section-header"
												onClick={() => {
													if (
														this.state.currStep !== '3' &&
														this.state.projectId &&
														this.state.eventId &&
														_.size(this.state.mcList) > 0 &&
														this.state.qrCodeError === false &&
														_.every(this.state.mcList, {
															status: 'ready',
														})
													) {
														this.setState({ currStep: '3' });
													}
												}}
											>
												<span className="section-header-title">Assign</span>
												<span className="section-header-down-icn">
													<DownIcon />
												</span>
											</div>
										</div>
									) : (
										<div className="mc-body-section-container">
											<div className="mc-body-section-header">
												<span className="section-header-title">Assign</span>
												<span className="section-header-down-icn expanded">
													<DownIcon />
												</span>
											</div>
											<div className="mc-body-input-container">
												<div className="floating-select-container">
													<label>
														Assign to
														<span className="required-star">*</span>
													</label>
													<Select
														className={
															'cost-select-container zIndex3 w-100p'
														}
														classNamePrefix="cost-select"
														options={this.state.tenantUsersListOptions}
														onChange={(e) =>
															this.setState({
																assignedTo: e.value,
																assignedToCrew: e.label,
															})
														}
														defaultValue={[
															this.state.assignedTo === null
																? this.state
																		.tenantUsersListOptions[0]
																: _.find(
																		this.state
																			.tenantUsersListOptions,
																		{
																			value: this.state
																				.assignedTo,
																		},
																  ),
														]}
														components={{
															DropdownIndicator:
																this.DropdownIndicator,
														}}
														isSearchable={true}
														disabled={this.state.isAssignLoading}
													/>
												</div>
											</div>
											{this.state.isAssignError ? (
												<div className="mc-error">
													{this.state.isAssignErrorMessage}
												</div>
											) : null}
										</div>
									)}
								</div>
							) : (
								<div className="mc-body-container-print">
									{/* <div className="assigned-item-text">Assigned ID {''}</div> */}
									<table className="mc-table gray-border">
										<thead>
											<tr>
												<th>QR CODE</th>
												<th>DESCRIPTION</th>
												<th>READY TO USE</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{_.map(this.state.mcList, (mc, index) => {
												return (
													<tr>
														<td>
															<div
																className={
																	'mc-table-cell' +
																	(mc.status === 'ready'
																		? ''
																		: ' red-color-text')
																}
															>
																{mc.qrCode.toUpperCase()}
															</div>
														</td>
														<td>
															<div
																className={
																	'mc-table-cell' +
																	(mc.status === 'ready'
																		? ''
																		: ' red-color-text')
																}
															>
																<span>{mc.description}</span>
															</div>
														</td>
														<td>
															<div
																className={
																	'mc-table-cell' +
																	(mc.status === 'ready'
																		? ' green-color-text'
																		: ' red-color-text')
																}
															>
																{mc.status === 'ready'
																	? 'Yes'
																	: 'No'}
															</div>
														</td>
														<td></td>
													</tr>
												);
											})}
										</tbody>
									</table>
									<div className="mc-input-container">
										<InputHeader
											type="text"
											name="assignTo"
											isInputError={false}
											label="Assign to"
											value={
												_.find(this.state.tenantUsersListOptions, {
													value: this.state.assignedTo,
												}).label
											}
											onChange={(e) => {}}
											errorMessage={''}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={true}
										/>
									</div>
									<div className="mc-input-container">
										<InputHeader
											type="text"
											name="project"
											isInputError={false}
											label="Project"
											value={
												_.find(this.state.projectNameOptions, {
													value: this.state.projectId,
												}).label
											}
											onChange={(e) => {}}
											errorMessage={''}
											width="100%"
											marginBottom="0px"
											readOnly
										/>
									</div>
									<div className="mc-input-container">
										<InputHeader
											type="text"
											name="event"
											label="Event"
											value={
												_.find(this.state.eventNameOptions, {
													value: this.state.eventId,
												}).label
											}
											width="100%"
											marginBottom="0px"
											readOnly
										/>
									</div>
									<div className="assigned-item-text assgnd-by">
										Assigned by {this.state.currUserName} on{' '}
										{moment().format('h:mma DD/MM/YYYY')}
									</div>
								</div>
							)}
							<div className="mc-foother-btn-container">
								<span
									className="left-cancel-btn"
									onClick={() => {
										this.props.handleClose();
									}}
								>
									{this.state.isAssignLoading === true
										? ''
										: this.state.currStep === '4'
										? 'Close'
										: 'Cancel'}
								</span>

								{this.state.currStep === '1' ? (
									<span
										className={
											'add-edit-btn' +
											(this.state.projectId && this.state.eventId
												? ''
												: ' disabled')
										}
										onClick={() => {
											if (this.state.projectId && this.state.eventId) {
												this.setState(
													{
														currStep: `${
															parseInt(this.state.currStep) + 1
														}`,
													},
													() => {
														if (
															document.getElementById(
																'qrCodeId-kjsdfk4df54g4dfg5d4f',
															)
														) {
															document
																.getElementById(
																	'qrCodeId-kjsdfk4df54g4dfg5d4f',
																)
																.focus();
														}
													},
												);
											}
										}}
									>
										Next
										{this.state.projectId && this.state.eventId ? (
											<span className="next-icon">
												<DownIcon />
											</span>
										) : null}
									</span>
								) : this.state.currStep === '2' ? (
									<span
										className={
											'add-edit-btn' +
											(this.state.projectId &&
											this.state.eventId &&
											_.size(this.state.mcList) > 0 &&
											this.state.qrCodeError === false &&
											_.every(this.state.mcList, {
												status: 'ready',
											})
												? ''
												: ' disabled')
										}
										onClick={() => {
											if (
												this.state.projectId &&
												this.state.eventId &&
												_.size(this.state.mcList) > 0 &&
												this.state.qrCodeError === false &&
												_.every(this.state.mcList, {
													status: 'ready',
												})
											) {
												this.setState({
													currStep: `${
														parseInt(this.state.currStep) + 1
													}`,
												});
											}
										}}
									>
										Next
										<span className="next-icon">
											<DownIcon />
										</span>
									</span>
								) : this.state.currStep === '3' ? (
									this.state.isAssignLoading === true ? (
										<span className={'add-edit-btn loading-btn'}>
											<LoadingBar />
											Assign Memory cards
										</span>
									) : (
										<span
											className={
												'add-edit-btn' +
												(this.state.projectId &&
												this.state.eventId &&
												_.size(this.state.mcList) > 0 &&
												this.state.qrCodeError === false &&
												_.every(this.state.mcList, {
													status: 'ready',
												}) &&
												this.state.assignedTo
													? ''
													: ' disabled')
											}
											onClick={() => {
												if (
													this.state.projectId &&
													this.state.eventId &&
													_.size(this.state.mcList) > 0 &&
													this.state.qrCodeError === false &&
													_.every(this.state.mcList, {
														status: 'ready',
													}) &&
													this.state.assignedTo
												) {
													this.handleAssignMC();
												}
											}}
										>
											Assign Memory cards
										</span>
									)
								) : this.state.currStep === '4' ? (
									<span
										className="add-edit-btn"
										onClick={(e) =>
											window.open(
												`https://pdf.huemn.com/memory-cards/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
											)
										}
									>
										Print Summary
									</span>
								) : null}
							</div>
						</>
					)}
				</div>
				<Modal
					handleClose={() => this.setState({ showDiscardModal: false })}
					show={this.state.showDiscardModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">DISCARD CHANGES</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you discard this information, you cannot undo this
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) => this.setState({ showDiscardModal: false })}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.props.handleClose();
									this.setState({ showDiscardModal: false });
								}}
							>
								Yes, Discard
							</span>
						</div>
					</div>
				</Modal>
			</Modal>
		);
	}
}

export default withRouter(AssignMemoryCard);
